import { mi } from './mi';
import miMessages from '../locales/mi-MI';

const MiLang = {
    messages: {
        ...miMessages
    },
    locale: 'mi-MI',
    data: mi
};
export default MiLang;